import React from "react";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import { UserType } from "../../../data/enums";

interface LandingNutritionistsProps {
  redirect: (path: string) => void;
}

function LandingNutritionists({ redirect }: LandingNutritionistsProps) {
  return (
    <div className="landing-nutritionists">
      <Typography variant="h2" component="h2" id="landing-nutritionists-h" className="landing-title">
        ¿Sos nutricionista?
      </Typography>
      <div className="landing-nutritionists-body">
        <div className="landing-nutritionists-info">
          <Typography variant="body1" component="p" className="landing-p">
            Alcanza las metas de salud con tus pacientes, diseñando dietas
            personalizadas basadas en su ADN.
          </Typography>
          <Typography variant="body1" component="p" className="landing-p">
            El Test de nutrición y genética de Mr. Gen es tu mejor partner para
            brindar a tus pacientes recomendaciones nutricionales asociadas a su
            genotipo y lograr con esto una dieta efectiva y con rápidos
            resultados.
          </Typography>
          <Typography variant="body1" component="p" className="landing-p">
            Por cada paciente que recomiendes podrás obtener ganancias.
          </Typography>
          <Button
            id="landing-nutritionists-button-desktop"
            color="primary"
            variant="contained"
            onClick={() => redirect(`/signup?user=${UserType.Nutritionist}`)}
            disableElevation
          >
            Quiero saber más
          </Button>
        </div>
        <div className="landing-nutritionists-decoration">
          <div
            id="landing-nutritionists-image"
            className="landing-square-image"
          />
          <div id="landing-nutritionists-circle" />
        </div>
        <Button
            id="landing-nutritionists-button-mobile"
            color="primary"
            variant="contained"
            onClick={() => redirect("/signup?user=2")}
            disableElevation
          >
            Quiero saber más
          </Button>
      </div>
    </div>
  );
}

export default LandingNutritionists;
